import React, {useState} from 'react';
import {useNavigate, Link} from 'react-router-dom';
import burger from "../../assets/align-right.svg";
import logo from '../../assets/logo.svg';
import logoDark from '../../assets/logo-dark.svg';
import Drawer from "../Drawer/drawer.js";
import Menu from "../Menu/menu.js";
import {useAuth} from "../../utils/authContext.js";
import {useLanguage} from "../../utils/languageContext.js";
import {getTranslation} from "../../utils/translate.js";
import DarkModeToggle from "../DarkModeToggle/darkModeToggle.js";
import {useDarkMode} from "../../utils/darkModeContext.js";
import LanguageSwitcher from '../LanguageSwitcher/languageSwitcher.js';
import Button from '../comman/button.js';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const {fullNameAm} = useAuth();
    const {language} = useLanguage();
    const {isDarkMode} = useDarkMode();
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('fullNameHy');
        localStorage.removeItem('authToken')
        navigate('/login');
    };

    const userInitials = fullNameAm
        ? fullNameAm.split(" ").map((name) => name[0]).join("").toUpperCase()
        : "";

    return (
        <>
            <header
                className="flex items-center justify-between px-6 py-3.5 bg-white dark:bg-[#161b22] shadow-sm border-b border-gray-200 dark:border-[#30363d]">
                <div className="sm:hidden">
                    <img 
                        src={isDarkMode ? logoDark : logo} 
                        alt="Logo" 
                        className="w-[121px] h-[30px]"
                        onError={(e) => {
                            console.error("Failed to load logo:", isDarkMode ? logoDark : logo);
                            e.target.onerror = null;
                            e.target.src = "/favicon.svg";
                        }}
                    />
                </div>
                <div className="hidden sm:block">
                </div>
                <div className="flex items-center space-x-3">
                    <div className="hidden sm:flex items-center space-x-3">
                        <DarkModeToggle />
                        <LanguageSwitcher />
                    </div>
                    <button
                        className="hidden sm:inline-block text-gray-600 dark:text-[#c9d1d9] font-bold text-sm bg-white dark:bg-[#161b22] px-4 py-2 rounded-md transition hover:bg-gray-50 dark:hover:bg-[#1c2128] hover:text-gray-800 dark:hover:text-[#f0f6fc] border dark:border-[#30363d]"
                        onClick={handleLogout}
                    >
                        {getTranslation('common.logout', language)}
                    </button>
                    <div
                        className="relative group cursor-pointer"
                        onClick={() => navigate('/profile')}
                    >
                        <div
                            className="flex items-center justify-center bg-customBlack dark:bg-[#161b22] text-sm text-white dark:text-[#c9d1d9] font-bold w-[42px] h-[42px] rounded-full transition hover:bg-customHoverBlack dark:hover:bg-[#1c2128] ring-4 ring-transparent group-hover:ring-gray-100 dark:group-hover:ring-[#30363d] border dark:border-[#30363d]">
                            {userInitials}
                        </div>
                    </div>
                    <div className="sm:hidden">
                        <img
                            src={burger || ''}
                            alt="burger"
                            onClick={() => setIsOpen(!isOpen)}
                            className="cursor-pointer dark:invert dark:opacity-80"
                            onError={(e) => {
                                console.error("Failed to load burger icon:", burger);
                                e.target.onerror = null;
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                </div>
            </header>
            <Drawer isOpen={isOpen} toggleDrawer={() => setIsOpen(!isOpen)}>
                <Menu onItemClick={() => setIsOpen(false)} isModal={true}/>
                <div className="flex items-center justify-center space-x-3 mb-4 mt-4 px-2">
                    <DarkModeToggle />
                    <LanguageSwitcher />
                </div>
                <Button
                    variant="secondary"
                    size="md"
                    onClick={handleLogout}
                    className="w-full font-bold mb-2 py-7"
                >
                    {getTranslation('common.logout', language)}
                </Button>
                <button
                    className="py-7 rounded-md"
                >
                    <Link
                        to="/development"
                        className="text-red-600 dark:text-red-400 hover:text-gray-900 dark:hover:text-[#c9d1d9] text-xs font-medium"
                        onClick={() => setIsOpen(false)}
                    >
                        Development Menu
                    </Link>
                </button>
            </Drawer>
        </>
    );
};

export default Header;
